import React from 'react'
import MaterialSymbol from '../material-symbol'

const NavigateNext = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="navigate_next" {...props} />
))

NavigateNext.displayName = 'NavigateNext'

export default NavigateNext
